import {createContext} from 'react';

export const AddressContext = createContext("");